module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu01-9140ad45213a5ebe8f89dc1efe28c76b.gif";